module.exports = __webpack_public_path__ + "img/zone150400.fa307319.png";